import script from "./MediaflowDock.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowDock.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowDock.vue?vue&type=style&index=0&id=0054cfc6&lang=css"

const __exports__ = script;

export default __exports__